import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=afdd4cbe&scoped=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=afdd4cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdd4cbe",
  null
  
)

export default component.exports